import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { ValidationErrors } from '../../../lib/models/validation/validation-errors';
import { ProductPickerDto } from '../../models/product-picker-dto.model';

@Directive()
export class BaseProductPickerSearchCriteriaComponent {
  @Input() public filter: ProductPickerDto;
  @Input() public validationErrors: ValidationErrors;
  @Output() public readonly search = new EventEmitter<void>();
  @Output() public readonly clearFilters = new EventEmitter<void>();
  @Output() public readonly searchCriteriaChange = new EventEmitter<void>();
  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;

  public computeLTV(): void {
    const propertyValue =
      this.filter.Filter.PurchaseOrRemortgageCode !== this.referenceDataLabels.RemortgageId
        ? this.filter.PurchasingAtConcessionaryPriceCode === this.referenceDataOptionLists.AnswerTypeYes
          ? this.filter.PurchasePropertyPrice > this.filter.TrueMarketPrice * 0.75
            ? this.filter.PurchasePropertyPrice < this.filter.TrueMarketPrice
              ? this.filter.PurchasePropertyPrice
              : this.filter.TrueMarketPrice
            : this.filter.TrueMarketPrice
          : this.filter.PurchasePropertyPrice
        : this.filter.RemortgageEstimatedPropertyValue;

    this.filter.Ltv =
      propertyValue && this.filter.LoanAmount ? Math.ceil((this.filter.LoanAmount / propertyValue) * 100) : undefined;
  }

  public updateRepaymentPart(): void {
    if (this.filter.RepaymentTypeCode === this.referenceDataOptionLists.RepaymentTypePartAndPart) {
      this.filter.RepaymentPart =
        this.filter.LoanAmount && this.filter.InterestOnlyPart !== undefined
          ? this.filter.LoanAmount - this.filter.InterestOnlyPart
          : undefined;
    }
  }

  public purchasingAtConcessionaryPriceCodeChange(value: string): void {
    this.filter.PurchasingAtConcessionaryPriceCode = value;
    this.computeLTV();
    if (this.filter.PurchasingAtConcessionaryPriceCode === this.referenceDataOptionLists.AnswerTypeYes) {
      this.filter.TrueMarketPrice = undefined;
    }
  }

  public repaymentTypeCodeChange(value: string): void {
    this.filter.RepaymentTypeCode = value;
    if (this.filter.RepaymentTypeCode === this.referenceDataOptionLists.RepaymentTypePartAndPart) {
      this.filter.InterestOnlyPart = undefined;
      this.filter.RepaymentPart = undefined;
    }
  }

  public epcRatingChange(value: string): void {
    this.filter.PropertyEPCRatingCode = value;
  }
}
